import { Site, SLD } from '@patsnap-utils/biz';
import { getFreeRegisterUrlParams } from '../utils/get-register-url-params';

export function useLinks() {
    const EUREKA_CLIENT_NAME = import.meta.env.VITE_PASSPORT_CLIENT_NAME

    const EUREKA_CLIENT_ID = import.meta.env.VITE_PASSPORT_CLIENT_ID

    const EUREKA_URL = import.meta.env.VITE_EUREKA_URI

    function generateRedirectUri() {
        const registerParams = getFreeRegisterUrlParams();
        if (registerParams.inviter_id) {
            return `/home?channel_source=${registerParams.channel_source}&activity_type=${registerParams.activity_type}&inviter_id=${registerParams.inviter_id}`;
        }
        return '/home';
    }

    function generateAccountLoginLink(email?: string) {
        const registerParams = getFreeRegisterUrlParams();
        const data = {
            ...registerParams,
            from: EUREKA_CLIENT_NAME,
            redirect_uri: `${EUREKA_URL}${generateRedirectUri()}`,
            client_id: EUREKA_CLIENT_ID,
            email,
            tab: 'password',
        };
        const params = new URLSearchParams();
        Object.keys(data).forEach((key) => {
        // @ts-ignore
            if (data[key]) {
            // @ts-ignore
                params.append(key, data[key]);
            }
        });
        return `${new Site({ sld: SLD.ACCOUNT }).href}?${params.toString()}`;
    }

    return {
        generateAccountLoginLink,
        generateRedirectUri,
    };
}
